import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Card, CardMedia, Container, makeStyles } from '@material-ui/core';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import Constants from '@/constants.js';
import mainStyles from '@/assets/js/mainStyles.js';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

const useStyles = makeStyles(mainStyles);

const CustomProductsDocuments = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [customProduct, setCustomProduct] = useState({});
  const { setTitle } = usePage();
  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

  useEffect(async () => {
    const fetch = async () => {
      const response = await Request.get(`/custom-products/${id}`);
      setCustomProduct(response);
    };
    setTitle('Produits sur mesure');
    await fetch();
  }, []);
  const customProductData = customProduct.documents
    ? customProduct.documents
    : {
        file: null,
        image: null,
      };

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        <div
          className={classes.subTitle}
          style={{ fontSize: 26, display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap' }}
        >
          <span>{customProduct?.title} </span>
        </div>
        {customProductData.image && (
          <Card className={classes.imgCard}>
            <CardMedia
              className={classes.imgItem}
              component="img"
              image={`${Constants.BASE_URL}/${customProductData.image.path} `}
            />
          </Card>
        )}
        {customProductData.file && (
          <div className={classes.pdfViewer}>
            {/* eslint-disable-next-line react/jsx-no-undef */}
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
              <div style={{ textAlign: 'center' }}>
                <ZoomOut>
                  {(props) => (
                    <Button style={{ width: 100, height: 20 }} className={classes.outlinedBtn} onClick={props.onClick}>
                      ZoomOut
                    </Button>
                  )}
                </ZoomOut>
                <CurrentScale>
                  {(props) => <span style={{ padding: 10 }}>{`${Math.round(props.scale * 100)}%`}</span>}
                </CurrentScale>
                <ZoomIn>
                  {(props) => (
                    <Button style={{ width: 100, height: 20 }} className={classes.outlinedBtn} onClick={props.onClick}>
                      ZoomIn
                    </Button>
                  )}
                </ZoomIn>
              </div>
              <Viewer
                fileUrl={`${Constants.BASE_URL}/${customProductData.file.path} `}
                defaultScale={SpecialZoomLevel.PageFit}
                plugins={[zoomPluginInstance]}
              />
            </Worker>
          </div>
        )}
      </Box>
    </Container>
  );
};

export default CustomProductsDocuments;
